module.exports = __webpack_public_path__ + "img/figure05_sp.207e3701.png";